import React from 'react'

const NumericBodyTemplate = ({ rowData, field, decimalPlaces = null }) => {
    const value = rowData[field]
    if (value === null || value === undefined) {
        return <span></span>
    }
    // If decimalPlaces is specified, format the number and trim trailing zeros
    const displayValue = decimalPlaces !== null
        ? parseFloat(value.toFixed(decimalPlaces))
        : value
    return <span>{displayValue}</span>
}

export default NumericBodyTemplate
